(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('CustomerNotificationDialogController', CustomerNotificationDialogController);

    CustomerNotificationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CustomerNotification', 'Customer'];

    function CustomerNotificationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CustomerNotification, Customer) {
        var vm = this;

        vm.customerNotification = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.customers = Customer.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customerNotification.id !== null) {
                CustomerNotification.update(vm.customerNotification, onSaveSuccess, onSaveError);
            } else {
                CustomerNotification.save(vm.customerNotification, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bozorakaAdminApp:customerNotificationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.pushDate = false;
        vm.datePickerOpenStatus.expiryDate = false;
        vm.datePickerOpenStatus.createdDate = false;
        vm.datePickerOpenStatus.lastModifiedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
